import React, { useContext } from 'react';

import {
	IconReactionPositiveSmall,
	IconReactionNegativeSmall,
} from '@sololearnorg/sol';
import { Container, i18n } from '../../../../symphony';

import { SlAISolutionsContext } from '../../global-constants';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../global-interface';
import { SlDataService } from '../../services/sl-data.service';
import { KodieContext } from '../../services/context';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';

interface IAISolutionRatingProps {
	id: string;
	solutionType: number;
}

export function AISolutionRating({ id, solutionType }: IAISolutionRatingProps) {
	const { context } = useContext(KodieContext);
	const { actions$ } = Container.take(SlAISolutionsContext, SlActions);
	const { aiSolutionsRate$: aiSolutionsRate } = useContainerData(
		SlAISolutionsContext,
		SlDataService,
		['aiSolutionsRate$'],
	);

	const solutionRateHandler = (
		solutionId: string,
		solutionRating: number,
	) => {
		actions$.next({
			type: ActionType.OnAISolutionRate,
			requestType: RequestType.Parallel,
			data: {
				solutionId,
				solutionRating,
				solutionType,
				solutionContext: context,
			},
		});
	};

	return (
		<div className="ai-solutions__main-section__solution__content__rate-section">
			<div className="ai-solutions__main-section__solution__content__rate-section__title">
				{i18n.t('web-kodie.rate-message')}
			</div>
			<div className="ai-solutions__main-section__solution__content__rate-section__buttons">
				<IconReactionPositiveSmall
					onClick={() => {
						solutionRateHandler(id, 1);
					}}
					className={
						aiSolutionsRate[solutionType] === 1
							? 'active'
							: 'inactive'
					}
				/>
				{' '}
				<IconReactionNegativeSmall
					onClick={() => {
						solutionRateHandler(id, 2);
					}}
					className={
						aiSolutionsRate[solutionType] === 2
							? 'active'
							: 'inactive'
					}
				/>
			</div>
		</div>
	);
}
